import React, { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import style from "./CheckButton.module.css";
import Button from "@/ui/button/Button";
import { useNavigate, useParams } from "react-router-dom";
import { useGetCourseUnits } from "@/features/courses/hooks/useGetCourseUnits";
import { useNextUnit } from "@/features/courses/hooks/useNextUnit";

function CheckButton({ dispatch, answer, index, questions }) {
	const { t } = useTranslation();
	const { courseSlug, moduleSlug, unitSlug } = useParams();
	const { course, modules, isPending, isSuccess, isError, error } =
		useGetCourseUnits({ courseSlug });

	const { nextUnit, nextUnitModule } = useNextUnit();

	const navigate = useNavigate();

	const handleKeyDown = useCallback(
		async (event) => {
			if (event.key === "Enter" && answer) {
				dispatch({ type: "checkAnswer", payload: answer });
			}
		},
		[answer, dispatch]
	);

	useEffect(() => {
		window.addEventListener("keydown", handleKeyDown);
		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, [handleKeyDown]);

	const handleClick = useCallback(() => {
		dispatch({ type: "checkAnswer", payload: answer });
	}, [answer, dispatch]);

	const openNextUnit = function () {
		if (nextUnit && nextUnitModule)
			return navigate(
				`/courses/${courseSlug}/${nextUnitModule?.slug}/${nextUnit?.slug}`
			);

		return navigate("/");
	};

	return index == questions.length ? (
		<Button className={style.check} onClick={openNextUnit}>
			{t("quiz:check.continue")}
		</Button>
	) : (
		<Button
			className={style.check}
			onClick={handleClick}
			disabled={!answer}
		>
			{t("quiz:check.submit")}
		</Button>
	);
}

export default CheckButton;
